import {
    info
} from '../../../core/js/utils/logger';
import queryString from 'query-string';
import { utagView } from '../../../core/js/utils/analyticsUtils';

/**
 * Parse the value string of the clicked category tag element, format utagData object and fire utag.view
 * @param {object} the action data
 * @returns {function} utag.view
 */
/* eslint-disable complexity */
function handleCategoryUtagView(cmEvent) {
    const elementName = cmEvent.target.dataset.elementName || '';
    const keyName = cmEvent.target.dataset.cmElement || '';
    const utagData = {};
    let valueString = '';
    let urlParams = {};

    if (elementName === 'page') {
        // pagination are links and not inputs so we need to get value from data-page-request attr
        valueString = cmEvent.target.dataset.pageRequest || '';
    } else {
        valueString = cmEvent.target.value || '';
    }

    urlParams = queryString.parse(valueString);
    utagData[keyName] = urlParams[elementName] || '';

    return () => {
        utagView(utagData);
        info(`utag.view fired: ${keyName}`);
    };
}

export function categoryTags() {
    return {
        category_facet_size: (state, action, cmEvent) => handleCategoryUtagView(cmEvent),
        category_facet_color: (state, action, cmEvent) => handleCategoryUtagView(cmEvent),
        category_facet_brand: (state, action, cmEvent) => handleCategoryUtagView(cmEvent),
        category_facet_inseam: (state, action, cmEvent) => handleCategoryUtagView(cmEvent),
        category_facet_occasion: (state, action, cmEvent) => handleCategoryUtagView(cmEvent),
        category_facet_rise: (state, action, cmEvent) => handleCategoryUtagView(cmEvent),
        category_facet_style: (state, action, cmEvent) => handleCategoryUtagView(cmEvent),
        category_facet_price: (state, action, cmEvent) => handleCategoryUtagView(cmEvent),
        category_facet_genre: (state, action, cmEvent) => handleCategoryUtagView(cmEvent),
        category_facet_heel: (state, action, cmEvent) => handleCategoryUtagView(cmEvent),
        category_facet_length: (state, action, cmEvent) => handleCategoryUtagView(cmEvent),
        category_facet_sleeve: (state, action, cmEvent) => handleCategoryUtagView(cmEvent),
        category_facet_type: (state, action, cmEvent) => handleCategoryUtagView(cmEvent),
        category_sort: (state, action, cmEvent) => handleCategoryUtagView(cmEvent),
        category_page_number: (state, action, cmEvent) => handleCategoryUtagView(cmEvent)
    };
}
